import React, { useState } from "react";
import locationimage from "../../assets/location-image.jpg";
import { useJourney } from "./JourneyProvider";
import { validateDevice } from "../../services/allowService";

export interface ScreenStyles {
  backgroundColor: string;
  textColor: string;
  buttonColor: string;
  buttonLabelColor: string;
}

interface LocationScreenProps {
  styles: ScreenStyles;
  onNext?: () => void;   // chama quem controla a navegação
}

const LocationScreen: React.FC<LocationScreenProps> = ({ styles, onNext }) => {
  const { cpf, ip, journey } = useJourney();
  const [isLoading, setIsLoading] = useState(false);

  const performValidation = async () => {
    if (isLoading) return;
    setIsLoading(true);

    try {
      let fingerprint = null;
      if ((window as any).Alwm) {
        try {
          // Coleta fingerprint novamente (re-collect), agora potencialmente com permissão de localização concedida
          // A sessão já foi iniciada na tela anterior, então isso é rápido e seguro.
          fingerprint = await (window as any).Alwm.collect("onboarding");
        } catch (e) {
          console.error("Erro ao coletar fingerprint (LocationScreen):", e);
        }
      } else {
        console.warn("Alwm SDK não encontrado no window.");
      }

      if (fingerprint) {
        const payload = {
          integrationName: "login",
          userId: cpf,
          userIp: ip,
          event: fingerprint,
          metadata: {
            email: journey?.email || undefined,
            cpf: cpf?.replace(/\D/g, ""),
            phones: [journey?.tel ?? ""].filter(Boolean),
          },
          protocol: journey?.protocol,
        };
        const { data } = await validateDevice(payload);
        console.log("Validação de device concluída (LocationScreen):", data);
      }
      
      onNext?.();
    } catch (err) {
      console.error("❌ Erro ao validar device (LocationScreen):", err);
      // Mesmo com erro na validação, não travamos o usuário na tela de location
      onNext?.();
    } finally {
      setIsLoading(false);
    }
  };

  const handleShare = () => {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          console.log("Localização obtida:", position);
          performValidation();
        },
        (error) => {
          console.error("Erro ao obter localização:", error);
          performValidation();
        }
      );
    } else {
      performValidation();
    }
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", height: "100%" }}>
      <div style={{ textAlign: "center", marginBottom: 24 }}>
        <img src={locationimage} alt="location" style={{ maxWidth: "100%" }} />
      </div>

      <p style={{ color: styles.textColor, fontWeight: 600, fontSize: 16, marginBottom: 8 }}>
        Compartilhe sua localização
      </p>
      <p style={{ color: styles.textColor, fontSize: 14, marginBottom: 24, textAlign: "justify" }}>
        Solicitamos essa permissão para aumentar a segurança da sua conta e das suas apostas
      </p>

      <button
        onClick={handleShare}
        disabled={isLoading}
        style={{
          width: "100%",
          padding: "12px 0",
          backgroundColor: styles.buttonColor,
          border: "none",
          borderRadius: 30,
          color: styles.buttonLabelColor,
          fontWeight: 600,
          fontSize: 16,
          opacity: isLoading ? 0.7 : 1,
          cursor: isLoading ? "wait" : "pointer"
        }}
      >
        {isLoading ? "Validando..." : "Compartilhar"}
      </button>

      <p
        style={{
          textAlign: "center",
          marginTop: 12,
          color: styles.textColor,
          fontWeight: 500,
          cursor: isLoading ? "wait" : "pointer",
          opacity: isLoading ? 0.7 : 1
        }}
        onClick={() => !isLoading && performValidation()}
      >
        Não Compartilhar
      </p>
    </div>
  );
};

export default LocationScreen;
